import { AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { AcmSupaDemo } from '../acm-supa-demo.service'
import { environment } from '@tv3/environments/environment'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-acm-supa-demo-dialog',
  templateUrl: './acm-supa-demo-dialog.component.html',
  styleUrls: ['./acm-supa-demo-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class AcmSupaDemoDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('demo') demo: ElementRef<HTMLElement>
  @ViewChild('loading') loading: ElementRef<HTMLElement>
  demoUrl: SafeResourceUrl
  constructor(
    private dialogRef: MatDialogRef<AcmSupaDemoDialogComponent>,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: { demo: AcmSupaDemo }
  ) {}

  ngOnInit(): void {
    this.demoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://app.supademo.com/embed/${this.data.demo.id}?embed_v=2`
    )
  }

  ngAfterViewInit(): void {
    this.demo.nativeElement.innerHTML = this.data.demo.embed
    setTimeout(() => {
      this.renderer.setStyle(this.demo.nativeElement, 'display', 'block')
      this.renderer.setStyle(this.loading.nativeElement, 'display', 'none')
    }, 3000)
  }

  close() {
    this.dialogRef.close()
  }

  goToACM() {
    window.open(`${environment.acmAppUrl}/login?token=${this.authService.token}&redirectURL=${location.pathname}`)
  }
}
